<div class="tips-modal">
  <h1 class="tips-title text-sm-center mb-3 fw-bold px-7 mx-sm-0">
    Are&nbsp;you&nbsp;satisfied
    with&nbsp;the&nbsp;answer?
  </h1>
  <h3 class="tips-text text-body text-sm-center fw-bold mb-0 ps-7 pe-9 mx-sm-0">
    Tip your expert to say
    <span class="text-primblack">
      "Thank&nbsp;you"
    </span>&nbsp;😌
  </h3>
  <img src="/assets/hands.svg" alt="" class="tips-img w-100 mb-7">
  <div class="row flex-column align-items-center">
    <div class="col-10 col-sm-9">
      <button
        type="button"
        (click)="purchasePlan('be6c248d-0ea7-4906-8872-efd9c8fca345', 'low')"
        class="btn btn-outline border-2 app-btn-black w-100 mb-5">
        $5
      </button>
      <button
        type="button"
        (click)="purchasePlan('9e4699f5-27ad-425f-b312-4fd352f3116e', 'medium')"
        class="btn btn-outline border-2 app-btn-black w-100 mb-5">
        $10
      </button>
      <button
        type="button"
        (click)="purchasePlan('3da6a9fe-2130-467a-a557-2a3818da9d2b', 'high')"
        class="btn btn-outline border-2 app-btn-black w-100 mb-5">
        $15
      </button>
      <button
        type="button"
        (click)="thanks()"
        class="btn btn-outline border-2 app-btn-white w-100">
        No, thanks
      </button>
    </div>
  </div>
</div>
